<div class="logo d-xxl-flex d-none" [ngClass]="{'logo-red-box': isLanding}" (click)="onClick()">
  <img src="assets/icons/tracey_logo_header_white_artbox_transparent-01.svg" alt="Tracey logo"
       [style.width]="isLanding ? '83%' : '120px'">
</div>
